module.exports = __webpack_public_path__ + "eff387448bf88ebc404b3f1bb7bb6047.svg";